import React from 'react'
import { AccordionCard } from 'components/AccordionCard'
import { useCompanyDetailContextValue } from '../context/CompanyDetailProvider'
import {
  Box,
  Button,
  Flex,
  Label,
  Loading,
  Text,
  useAppTheme,
} from '@workwhile/ui'
import { CompanyLocation } from 'api/company/location'
import { Pencil } from 'lucide-react'
import { LocationEditModal } from './LocationEditModal/LocationEditModal'

const LocationRow = ({
  location,
  isLast,
}: {
  location: CompanyLocation
  isLast: boolean
}) => {
  const { radii } = useAppTheme()
  const {
    actions: {
      locationEditModal: { openModal: openLocationEditModal },
    },
  } = useCompanyDetailContextValue()

  const onLocationEditClick = () => {
    openLocationEditModal(location)
  }

  return (
    <Box
      border="1px solid"
      borderColor="neutrals.100"
      p={3}
      borderRadius={radii.standard}
      width="100%"
      mb={isLast ? 0 : 3}
      justifyContent="space-between"
    >
      <Flex
        flexDirection="row"
        data-context-key="location_id"
        data-context-value={location.id}
        data-context-label={location.name}
        alignItems="center"
        justifyContent="space-between"
        gap={2}
      >
        <Flex flexDirection="row" alignItems="center" gap={2}>
          <Text>
            {location.name} ({location.id})
          </Text>
          {location.hidden ? (
            <Label variant="warning" size="small">
              Hidden
            </Label>
          ) : null}
        </Flex>
        <Button onClick={onLocationEditClick} variant="text" kind="small">
          <Pencil size={16} />
        </Button>
      </Flex>
    </Box>
  )
}

export const Locations = () => {
  const {
    state: { locations, locationEditModal },
    actions: {
      locationEditModal: { closeModal: closeLocationEditModal },
    },
  } = useCompanyDetailContextValue()

  const isLocationEditModalOpen = !!locationEditModal.location

  const locationRows = locations.data.map((location, index) => {
    return (
      <LocationRow
        key={`location-rows-${location.id}-${index}`}
        location={location}
        isLast={index === locations.data.length - 1}
      />
    )
  })

  return (
    <>
      <AccordionCard
        title={
          <Flex justifyContent="space-between" alignItems="center" gap={2}>
            <Text fontSize={2} color="lightText">
              Locations
            </Text>
            <Label
              variant="none"
              size="medium"
              style={{
                padding: 8,
              }}
            >
              {locations.data.length}
            </Label>
            {locations.isFetching ? <Loading type="button" /> : null}
          </Flex>
        }
        isAccordion
        defaultOpen={false}
      >
        {locationRows.length > 0 ? (
          locationRows
        ) : (
          <Text color="lightText" fontSize={1}>
            No locations found
          </Text>
        )}
      </AccordionCard>
      {isLocationEditModalOpen && locationEditModal.location ? (
        <LocationEditModal
          location={locationEditModal.location}
          onClose={closeLocationEditModal}
        />
      ) : null}
    </>
  )
}
